import { render, staticRenderFns } from "./resolve-accident.vue?vue&type=template&id=e469f2d6&scoped=true&"
import script from "./resolve-accident.vue?vue&type=script&lang=js&"
export * from "./resolve-accident.vue?vue&type=script&lang=js&"
import style0 from "./resolve-accident.vue?vue&type=style&index=0&id=e469f2d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e469f2d6",
  null
  
)

export default component.exports